/* eslint-disable */
const Sentry = require('@sentry/nextjs');
const Cookie = require('js-cookie');
const { isApolloError } = require('@apollo/client');
const { default: getApolloErrorType } = require('./getApolloErrorType');

module.exports = () => ({
    Sentry,
    captureException: (err, ctx) => {
        Sentry.withScope(scope => {
            if (err.message) {
                // De-duplication currently doesn't work correctly for SSR / browser errors
                // so we force deduplication by error message if it is present
                scope.setFingerprint([err.message]);
            }

            if (err.statusCode) {
                scope.setExtra('statusCode', err.statusCode);
            }

            if (isApolloError(err)) {
                scope.setExtra('apiErrorName', err.name);
                scope.setExtra('apiStatusCode', getApolloErrorType(err));
                scope.setExtra('apiErrorMessage', err.message);
                scope.setExtra('apiErrorExtraInfo', err.extraInfo);
                scope.setExtra('apiErrors', err.graphQLErrors);
            }

            scope.setTag('ssr', typeof window === 'undefined');

            if (ctx) {
                const { req, res, errorInfo, query, pathname } = ctx;

                if (res && res.statusCode) {
                    scope.setExtra('statusCode', res.statusCode);
                }

                if (typeof window !== 'undefined') {
                    scope.setExtra('query', query);
                    scope.setExtra('pathname', pathname);

                    // On client-side we use js-cookie package to fetch it
                    const sessionId = Cookie.get('sid');
                    if (sessionId) {
                        scope.setUser({ id: sessionId });
                    }
                } else {
                    scope.setExtra('url', req.url);
                    scope.setExtra('method', req.method);
                    scope.setExtra('headers', req.headers);
                    scope.setExtra('params', req.params);
                    scope.setExtra('query', req.query);

                    // On server-side we take session cookie directly from request
                    if (req.cookies?.sid) {
                        scope.setUser({ id: req.cookies.sid });
                    }
                }

                if (errorInfo) {
                    Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));
                }
            }

            Sentry.captureException(err);
        });
    },
});
